import React, {useState} from "react";
import Box from "@mui/material/Box";
import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";
import Fab from '@mui/material/Fab';
import AddIcon from '@mui/icons-material/Add';

import AppFooter from "../../components/common/AppFooter";
import EmployeeList from "../../components/dashboard/EmployeeList";
import AccountRequests from "../../components/dashboard/AccountRequests";
import EmployeeForm from "../../components/dashboard/EmployeeForm";
import Stack from "@mui/material/Stack";
import EvvSearcher from "../../components/dashboard/EvvSearcher";
import Title from "../../components/common/Title";
import SelectOption from "../../components/common/SelectOption";

function DashboardEmployees(props) {
    const [selection, setSelection] = useState("");
    const [searchOptions, setSearchOptions] = useState([{name: "Email", value: "email"}, {
        name: "EmpId",
        value: "empId"
    }])
    const blankForm = {
        email: '',
        empId: '',
        empName: '',
        empPhone: '',
        empAddress: ''
    };

    const [showEmployeeForm, setShowEmployeeForm] = React.useState(false);
    const [empFormState, setEmpFormState] = React.useState(blankForm);

    const handleShowEmpForm = () => setShowEmployeeForm(true);
    const handleCloseEmpForm = () => {
        setShowEmployeeForm(false);
        setEmpFormState(blankForm);
    }
    const handleAccountEdit = (accountObj) => {
        handleShowEmpForm(true);

        setEmpFormState(accountObj);
    }

    return (
        <React.Fragment>
            <EmployeeForm
                open={showEmployeeForm}
                handleClose={handleCloseEmpForm}
                initialValues={empFormState}
                setSearchBy={setSearchOptions}
            />
            <Box sx={{'& > :not(style)': {m: 1, position: 'absolute', bottom: '10%', right: '4%'}}}>
                <Fab color="primary" aria-label="add" onClick={handleShowEmpForm}>
                    <AddIcon/>
                </Fab>
            </Box>
            <Container maxWidth="xl" sx={{mt: 4, mb: 4}}>
                <Grid container spacing={1}>
                    <Grid item xs={12}>
                        <Stack direction={{xs: 'column', sm: 'row'}}
                               spacing={{xs: 1, sm: 2, md: 4}}
                               justifyContent="start"
                               sx={{mb: 1}}>
                            <Title>Employees</Title>
                            <Stack direction={{xs: 'column', sm: 'row'}}
                                   spacing={{xs: 1}}>
                                <SelectOption
                                    options={searchOptions}
                                    selection={selection}
                                    setSelection={setSelection}
                                />
                                <EvvSearcher/>
                            </Stack>
                        </Stack>
                        <EmployeeList/>
                    </Grid>
                    <Grid item xs={12}>
                        <AccountRequests
                            handleAccountEdit={handleAccountEdit}
                        />
                    </Grid>
                </Grid>
                <AppFooter/>
            </Container>

        </React.Fragment>
    );
}

export default DashboardEmployees;
